import React from "react";
import UseGetDashBoardData from "../../../../Components/Hooks/useDashboardData";
import { ModernStatWidget } from "./DashboardCard";
import NuAmount from "../../../../Components/Utils/NuAmount";

export default function PurchaseOrderstoSuppliers() {
  const { data } = UseGetDashBoardData(`/dashboard/purchaseOrderStats`);
  const percentage = parseFloat(data?.percentage_last_month) || 0;
  const isNegative = percentage < 0;

  const POIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="PO to Suppliers"
      value={data?.total_purchase_orders || 0}
      subValue={data?.total_price ? <NuAmount value={data?.total_price} /> : null}
      percentage={percentage}
      isNegative={isNegative}
      icon={POIcon}
      bgColor="bg-indigo-500/10"
      iconColor="text-indigo-600"
      badgeLabel="vs last month"
    />
  );
}
